export const logTypes = {
  1: "down",
  2: "up",
  99: "paused",
  98: "started"
}



// WEBPACK FOOTER //
// ./src/utils/uptime-robot-data.ts